const dataProject = [
    {
        title: "Página de tareas",
        image: "imgToDoList",
        index: 0,
        newProject: true,
        premierProject: false,
        urlPage: "https://todo-juangp.netlify.app",
        urlGit: "https://github.com/garciapereirajuan/to-do-list-mongoose",
        element: "AppToDoList"
    },
    {
        title: "Página autogestionable",
        image: "imgRotiseriaPepitos2",
        index: 1,
        newProject: true,
        urlPage: "https://rotiseria-pepitos.netlify.app",
        urlGit: "https://github.com/garciapereirajuan/negocio-app",
        element: "AppToDoList"
    },
    {
        title: "Página de Bar",
        image: "imgSocialGuamini2",
        index: 2,
        newProject: false,
        urlPage: "https://social-guamini.web.app",
        urlGit: "https://github.com/garciapereirajuan/pagina-de-bar",
        element: "AppToDoList"
    },
    {
        title: "Página de Servicios",
        image: "imgInfiniteLanguageStudio",
        index: 3,
        newProject: false,
        urlPage: "https://infinite-language-studio.web.app/es/home",
        urlGit: "https://github.com/garciapereirajuan/pagina-de-servicios",
        element: "AppTodoList"
    },
    {
        title:"Mapa coroplético con D3", 
        image: "imgChoroplethMap", 
        index: 4, 
        newProject: false,
        urlPage: "choropleth-map-d3js",
        urlGit: "https://github.com/garciapereirajuan/choropleth-map-d3js",
        element: "AppChoroplethMap"
    },
    {
        title:"Gráfico de dispersión con D3", 
        image: "imgScatterplotGraph", 
        index: 5, 
        newProject: false,
        urlPage: "scatterplot-graph-d3js",
        urlGit: "https://github.com/garciapereirajuan/scatterplot-graph-d3js",
        element: "AppScatterplotGraph"
    },
    {
        title: "Diagrama Treemap con D3",
        image: "imgTreemapDiagram",
        index: 6,
        newProject: false,
        urlPage:"diagrama-treemap-d3js",
        urlGit: "https://github.com/garciapereirajuan/treemap-diagram-d3js",
        element: "AppTreemapDiagram"
    },
    {
        title:"Calculadora JavaScript", 
        image: "imgCalculadoraDeJavaScript", 
        index: 7, 
        newProject: false,
        urlPage: "calculadora-de-javascript",
        urlGit: "https://github.com/garciapereirajuan/calculadora-javascript",
        element: "AppCalculadoraJS"
    },
    {
        title:"Caja de Ritmos", 
        image: "imgCajaDeRitmos", 
        index: 8, 
        newProject: false,
        urlPage: "caja-de-ritmos",
        urlGit: "https://github.com/garciapereirajuan/caja-de-ritmos",
        element: "AppCajaDeRitmos"
    },
    {
        title:"Editor de Markdown", 
        image: "imgEditorMarkdown2", 
        index: 9, 
        newProject: false,
        urlPage: "editor-de-markdown",
        urlGit: "https://github.com/garciapereirajuan/editor-de-markdown",
        element: "AppEditorMarkdown"
    },
    {
        title:"Máquina de frases", 
        image: "imgMaquinaCitas2", 
        index: 10, 
        newProject: false,
        urlPage: "maquina-de-citas",
        urlGit: "https://github.com/garciapereirajuan/maquina-de-citas",
        element: "AppMaquinaCitas"
    },
    {
        title:"Página Tributo", 
        image: "imgPaginaTributo2", 
        index: 11, 
        newProject: false,
        urlPage: "pagina-tributo/indra-devi",
        urlGit: "https://github.com/garciapereirajuan/pagina-tributo-indra-devi",
        element: "AppPaginaTributo"
    },
    {
        title:"Documentación Técnica", 
        image: "imgDocumentacionTecnica", 
        index: 12, 
        newProject: false,
        urlPage: "documentacion/tecnica-css",
        urlGit: "https://github.com/garciapereirajuan/documentacion-tecnica-css",
        element: "AppDocumentacionTecnica"
    },
    {
        title:"Destino de Productos", 
        image: "imgDestinoProductos", 
        index: 13, 
        newProject: false,
        urlPage: "destino-de-productos/comiendo-sano",
        urlGit: "https://github.com/garciapereirajuan/destino-de-productos-comiendo-sano",
        element: "AppDestinoProductos"
    },
    // {
    //     title:"Formulario de Encuesta", 
    //     image: "imgFormularioEncuesta", 
    //     index: 5, 
    //     urlPage: "formulario-de-encuesta",
    //     urlGit: "https://github.com/garciapereirajuan/maquina-de-citas",
    //     element: "AppFormularioEncuesta"
    // },
]

export default dataProject;